import { useMemo } from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { LearningContentCardsSkeleton } from 'academy-common-lib/components/Skeletons/LearningContentCardsSkeleton';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { LearningContentCard } from 'academy-common-lib/features/learningContentCard/components/LearningContentCard';
import { jsx as _jsx } from "react/jsx-runtime";
const ITEM_TYPE_TO_LEARNING_CONTENT_TYPE = {
  COURSE: 'TRACK',
  LESSON: 'LESSON',
  SHORT_VIDEO: 'SHORT_FORM_CONTENT'
};
export const AcademyRecommendations = ({
  section: {
    itemId,
    itemType,
    language
  }
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const items = useMemo(() => {
    const type = ITEM_TYPE_TO_LEARNING_CONTENT_TYPE[itemType];
    if (!type) return [];
    return [{
      id: itemId,
      type,
      language: itemType === 'COURSE' || itemType === 'LESSON' ? language === null || language === void 0 ? void 0 : language.toLowerCase() : undefined
    }];
  }, [itemId, itemType, language]);
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items,
    skip: !items.length
  });
  if (cardModelsLoading) {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: "400",
      marginBlockEnd: isMobile ? '400' : undefined,
      children: /*#__PURE__*/_jsx(LearningContentCardsSkeleton, {
        skeletonCardSize: isMobile ? 'small' : 'large',
        use: "on-light",
        maxSkeletonListLength: 1
      })
    });
  }
  if (cardModelsError || !(cardModels !== null && cardModels !== void 0 && cardModels.length)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    marginBlockStart: "400",
    marginBlockEnd: isMobile ? '400' : undefined,
    children: /*#__PURE__*/_jsx(View, {
      maxInlineSize: "300px",
      children: /*#__PURE__*/_jsx(LearningContentCard, {
        item: cardModels[0],
        size: isMobile ? 'small' : 'large'
      })
    })
  });
};